import { __assign, __rest } from "tslib";
import React from 'react';
import { useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { getIsUnverified } from '../../publicSession/selectors';
import { ArtBrandedDesktopPopup } from '../../ArtBrandedPopup';
import Button from '../../Button';
import VerificationEmailInput from '../../VerificationEmailInput';
import s from './VerificationPopupDesktop.scss';
export var VerificationPopupDesktop = function (_a) {
    var actionType = _a.actionType, email = _a.email, resendEmail = _a.resendEmail, onClose = _a.onClose, props = __rest(_a, ["actionType", "email", "resendEmail", "onClose"]);
    var t = useTranslation().t;
    var modalType = actionType ? 'action' : 'welcome';
    var isUnverified = useSelector(getIsUnverified);
    var title = t("verification.title.".concat(modalType), {
        action: t("verification.action.".concat(actionType)),
    });
    var tagline = t("verification.tagline.".concat(modalType));
    return (React.createElement(ArtBrandedDesktopPopup, __assign({ artImageSrc: Url.staticCDNLink('eclipse/sisu/image-11-620625097.jpg'), artAuthorUsername: 'AxiomDesign', title: title, tagline: tagline, className: s["".concat(modalType, "-modal")], titleClassName: s['title'], taglineClassName: s['tagline'], contentClassName: s['content'], popupProps: { isOpen: true }, onClose: onClose }, props),
        React.createElement("div", { className: s['text'] }, t("verification.checkEmail.".concat(modalType), {
            postProcess: 'reactPostprocessor',
            email: React.createElement("span", { className: s['email'] }, email),
        })),
        React.createElement("div", { className: s['text'] }, t("verification.instructions.".concat(modalType))),
        React.createElement("div", { className: s['buttons'] },
            React.createElement(Button, { view: "b3", height: "medium", className: s['button'], onClick: function () {
                    resendEmail();
                    onClose && onClose();
                } }, t('verification.resend')),
            !isUnverified && (React.createElement("div", { className: s['change-email'] },
                t('verification.notEmail', {
                    postProcess: 'reactPostprocessor',
                    email: React.createElement("span", { className: s['email'] }, email),
                }),
                React.createElement(VerificationEmailInput, { className: s['change-email-input'] })))),
        isUnverified && (React.createElement("div", { className: s['footer'] },
            React.createElement(Trans, { i18nKey: "verification.doormatBlurb" },
                "If you don't recognize this email or no longer have access to it, please contact support at",
                React.createElement("a", { target: "_blank", rel: "noreferrer", href: "mailto:accountrecovery@deviantart.com" }, "accountrecovery@deviantart.com"),
                " or",
                React.createElement("a", { target: "_blank", rel: "noreferrer", href: "https://www.deviantartsupport.com/en/article/what-should-i-do-if-ive-lost-access-to-my-account" }, "learn more here"),
                ".")))));
};
VerificationPopupDesktop.displayName = 'VerificationPopupDesktop';
export default VerificationPopupDesktop;
//# sourceMappingURL=VerificationPopupDesktop.js.map